module.exports = __webpack_public_path__ + "static/media/Sri Lanka.06e9848f.png";